import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaClock, FaEye } from 'react-icons/fa';
import API from '../api/axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => { API.get('/blog').then(r => setBlogs(r.data)).catch(console.error); }, []);

  return (
    <>
      <Navbar />
      <div style={{ paddingTop: '100px', minHeight: '100vh' }}>
        <div className="container">
          <div className="section-title"><h2>Blog</h2><p>Latest articles and insights</p></div>
          <div className="projects-grid">
            {blogs.map((blog, idx) => (
              <motion.div key={blog._id} className="project-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: idx * 0.1 }}>
                <div className="project-image" style={{ height: '180px', background: `linear-gradient(135deg, hsl(${idx * 45}, 60%, 45%), hsl(${idx * 45 + 60}, 60%, 35%))` }}>
                  <span style={{ fontSize: '2rem', position: 'relative', zIndex: 1 }}>📝</span>
                </div>
                <div className="project-info">
                  <span style={{ color: 'var(--primary)', fontSize: '0.8rem', fontWeight: '600' }}>{blog.category}</span>
                  <h3 style={{ marginTop: '5px' }}>{blog.title}</h3>
                  <p>{blog.excerpt}</p>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', color: 'var(--text-muted)', fontSize: '0.8rem' }}>
                    <span><FaClock /> {new Date(blog.createdAt).toLocaleDateString()}</span>
                    <span><FaEye /> {blog.views} views</span>
                  </div>
                  <Link to={`/blog/${blog.slug}`} className="btn btn-outline btn-small" style={{ marginTop: '10px' }}>Read More</Link>
                </div>
              </motion.div>
            ))}
          </div>
          {blogs.length === 0 && <p style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '40px' }}>No blog posts yet</p>}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogList;
